export const manageInteractiveReportConstants = {
  UPLOAD_INTERACTIVE_REPORT_REQUEST: "UPLOAD_INTERACTIVE_REPORT_REQUEST",
  UPLOAD_INTERACTIVE_REPORT_SUCCESS: "UPLOAD_INTERACTIVE_REPORT_SUCCESS",
  UPLOAD_INTERACTIVE_REPORT_FAILURE: "UPLOAD_INTERACTIVE_REPORT_FAILURE",

  RESET_INTERACTIVE_REPORT: "RESET_INTERACTIVE_REPORT"
};
